import CloseAccount from './CloseAccount';

export { CloseAccount };
